import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFactoryComponent } from '@effy-tech/acquisition-core';
import { WebsiteThemes } from '@effy-tech/acquisition-core/shared';

@Component({
  selector: 'acq-graphql',
  templateUrl: 'graphql.component.html',
  imports: [DynamicFactoryComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphqlComponent {
  protected readonly theme = WebsiteThemes.effy;
}
